/**
 * Map partner message `media` array into a DmFileAttachments-compatible shape.
 * GIF items stay separate (rendered with DmGifAttachment).
 */
export function partnerBlobAttachmentFromMedia(media) {
  const items = Array.isArray(media) ? media : [];
  const blobs = items.filter(
    (item) => item && (item.type === "image" || item.type === "file")
  );
  if (!blobs.length) return null;
  if (blobs.length === 1 && blobs[0].type === "image") {
    return { ...blobs[0], type: "image" };
  }
  return {
    type: "attachments",
    items: blobs.map((item) => ({
      ...item,
      type: "file",
      file_name: item.file_name || item.name || "File",
    })),
  };
}

export function partnerGifItemsFromMedia(media) {
  const items = Array.isArray(media) ? media : [];
  return items.filter((item) => item?.type === "gif");
}
